import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { config } from '../config';
@Injectable({
  providedIn: 'root'
})
export class UserDocumentService {

  constructor(
    private http: HttpClient
  ) { }





  addUserDocument(data): Observable<any> {
    console.log("data in main service", data);

    return new Observable<any>((observer) => {
      console.log("Observable");
      this.http.post(config.baseApiUrl + "userDocument", data).subscribe((res: any) => {
        console.log("Edited form: ", res);
        observer.next(res);
      }, err => {
        observer.error(err)
      }, () => {
        observer.complete();
      })
    });
  }



  getUserDocument(data): Observable<any> {
    let item = JSON.stringify(data)
    return new Observable<any>((observer) => {
      console.log("Observable");
      this.http.get(config.baseApiUrl + "userDocument?_id=" + item).subscribe((res: any) => {
        console.log("Get Courses : ", res);
        observer.next(res.data);
        // observer.complete();
      }, err => {
        observer.error(err)

      }, () => {
        observer.complete()
      })
    });
  }


  updateUserDocument(data): Observable<any> {
    console.log("data in main service", data);

    return new Observable<any>((observer) => {
      console.log("Observable");
      this.http.put(config.baseApiUrl + "userDocument", data).subscribe((res: any) => {
        console.log("Edited form: ", res);
        observer.next(res);
      }, err => {
        observer.error(err)
      }, () => {
        observer.complete();
      })
    });
  }

  /******************
   ****************************************************** 
    download users form ********************************
  */

  downloadAccidentPotrfolio(data): Observable<any> {
    console.log("portfolio data here", data);

    return new Observable<any>((observer) => {
      console.log("Observable");
      this.http.get(config.baseApiUrl + "userDocument/download?_id=" + data).subscribe((res: any) => {
        console.log("Edited form: ", res);
        observer.next(res.data);
      }, err => {
        observer.error(err)
      }, () => {
        observer.complete();
      })
    });

  }

  /***
   * Download All Form Zip in Single Accident
   * ****************************************************************************
   */


  downloadZipSingleAccident(data): Observable<any> {
    // console.log("portfolio data here", accidentId);
    // let data = { _id: accidentId }

    return new Observable<any>((observer) => {
      console.log("Observable");
      this.http.post(config.baseApiUrl + "userDocument/download", data).subscribe((res: any) => {
        console.log("Edited form: ", res);
        observer.next(res.data);
      }, err => {
        observer.error(err)
      }, () => {
        observer.complete();
      })
    });
  }

  downloadBreathAlcoholForm(data: any): Observable<any> {
    console.log("medical pdf download:", data);
    return new Observable<any>((observer) => {
      console.log("medical pdf download")
      console.log("Observable");
      this.http.get(config.baseApiUrl + "userDocument/breathAlcohol/download?_data=" + JSON.stringify(data)).subscribe((res: any) => {
        observer.next(res.data);
      }, err => {
        console.log("ERROR ", err)
        observer.error(err);
      },
        () => {
          console.log("CALL COMPLETED ")
          observer.complete();
        })

    });

  }

  getBreathAlcoholDocument(data): Observable<any> {
    let item = JSON.stringify(data)
    return new Observable<any>((observer) => {
      console.log("Observable");
      this.http.get(config.baseApiUrl + "userDocument/breathAlcohol?_id=" + item).subscribe((res: any) => {
        console.log("Get Courses : ", res);
        observer.next(res.data);
        // observer.complete();
      }, err => {
        observer.error(err)

      }, () => {
        observer.complete()
      })
    });
  }



  // SPONSON PACK FORM API CALL

  submitSponsorPackForm(data , profilePhoto): Observable<any> {
    console.log("data in main service", data);
    const finalData = new FormData()
    finalData.append('data'  , JSON.stringify(data))
    finalData.append('photo' , profilePhoto)
    return new Observable<any>((observer) => {
      console.log("Observable");
      this.http.post(config.baseApiUrl + "forms/sponsor-pack", finalData).subscribe((res: any) => {
        console.log("Edited form: ", res);
        observer.next(res);
      }, err => {
        observer.error(err)
      }, () => {
        observer.complete();
      })
    });
  }



  // PPE KIT API CALL

  getPPEKitList(instructorId?): Observable<any> {
    return new Observable<any>((observer) => {
      let query
      if (instructorId !== undefined) {
        query = `forms/ppekit/?_id=${instructorId}`
      } else {
        query = `forms/ppekit`
      }
      this.http.get(config.baseApiUrl + query).subscribe((res: any) => {
        observer.next(res.data)
      }, err => {
        observer.error(err)
      }, () => {
        observer.complete()
      })
    })
  }


  approvePPEKitRequest(ppeKitId): Observable<any> {
    let obj = {
      documentId: ppeKitId,
      status: 'approved'
    }
    return new Observable<any>((observer) => {
      console.log("Observable");
      this.http.get(config.baseApiUrl + "forms/ppekit-updatestatus/?_id=" + JSON.stringify(obj)).subscribe((res: any) => {
        console.log("Get Instructors : ", res);
        observer.next(res.data);
      }, (error) => {
        observer.error(error)
      }, () => {
        observer.complete();
      })
    });
  }


  rejectPPEKitRequest(ppeKitId): Observable<any> {
    let obj = {
      documentId: ppeKitId,
      status: 'submitted'
    }
    return new Observable<any>((observer) => {
      console.log("Observable");
      this.http.get(config.baseApiUrl + "forms/ppekit-updatestatus/?_id=" + JSON.stringify(obj)).subscribe((res: any) => {
        console.log("Get Instructors : ", res);
        observer.next(res);
      }, (error) => {
        observer.error(error)
      }, () => {
        observer.complete();
      })
    });
  }


  addPPEKitRequest(data): Observable<any> {
    return new Observable<any>((observer) => {
      console.log("Observable");
      this.http.post(config.baseApiUrl + "forms/ppekit", data).subscribe((res: any) => {
        console.log("Get Instructors : ", res);
        observer.next(res.data);
      }, (error) => {
        observer.error(error)
      }, () => {
        observer.complete();
      })
    });
  }

  downloadPPEKitSpreadSheet(): Observable<any> {
    return new Observable<any>((observer) => {
      this.http.get(config.baseApiUrl + "forms/ppekit-download").subscribe((res: any) => {
        observer.next(res);
      }, (error) => {
        observer.error(error)
      }, () => {
        observer.complete();
      })
    });
  }


  downloadPPEKitPdf(ppeId): Observable<any> {
    return new Observable<any>((observer) => {
      this.http.get(config.baseApiUrl + "forms/ppekit-download?_id=" + ppeId).subscribe((res: any) => {
        observer.next(res);
      }, (error) => {
        observer.error(error)
      }, () => {
        observer.complete();
      })
    });
  }


}
